import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Tokens da identidade (globals.css): sem isto o tailwind-merge le `text-13` como cor e apaga
// `text-white` (ou o contrario), e nao sabe que `rounded-item` substitui `rounded-full`.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["11", "12", "13", "14", "15", "titulo", "resumo", "kpi"],
      radius: ["card", "item", "miniatura"],
      shadow: ["hover", "painel", "modal", "ativo"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
